import { Schema } from "effect";

import { Label, ShortText } from "./dashboardSchemaPrimitives";
import { MetricFormat, MetricId, MetricSettling, MetricVerification } from "./metrics";

/**
 * What people can ask about: the areas with Verified metrics, each metric in
 * plain words with its trust label, and the areas that have no metrics yet.
 * Read by the Dashboards home so nobody has to guess what exists.
 */
export const DashboardDataCatalogMetric = Schema.Struct({
  id: MetricId,
  title: Label,
  description: Schema.String,
  format: MetricFormat,
  verified: MetricVerification,
  settling: Schema.optionalKey(MetricSettling),
  /** What it can be split by, in the words a person would use. */
  splitBy: Schema.Array(Label),
});
export type DashboardDataCatalogMetric = typeof DashboardDataCatalogMetric.Type;

export const DashboardDataCatalogArea = Schema.Struct({
  id: Schema.String,
  title: Label,
  description: ShortText,
  /** Questions that work today, in the words a person would type. */
  examples: Schema.Array(Schema.String),
  metrics: Schema.Array(DashboardDataCatalogMetric),
});
export type DashboardDataCatalogArea = typeof DashboardDataCatalogArea.Type;

export const DashboardDataCatalogPlannedArea = Schema.Struct({
  id: Schema.String,
  title: Label,
  description: ShortText,
});
export type DashboardDataCatalogPlannedArea = typeof DashboardDataCatalogPlannedArea.Type;

export const DashboardDataCatalog = Schema.Struct({
  areas: Schema.Array(DashboardDataCatalogArea),
  planned: Schema.Array(DashboardDataCatalogPlannedArea),
});
export type DashboardDataCatalog = typeof DashboardDataCatalog.Type;
